export function JobPostSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/job-post.svg'"></ng-include>`
    }
}